<div class="d-flex flex-column align-items-center">
    <div class="card mt-5 col-md-6 p-4 mr-0 p-gutter flex-auto max-w-[800px]">
        <div class="d-flex flex-column align-items-end" (click)="close()"> <span style="cursor: pointer;">&times;</span>
        </div>
        <h5>Flag Candidate</h5>
        <div class="container">
            <form (ngSubmit)="flagCandidate()">
                <div class="row">
                    
                    <div class="col">
                        <label for="flagReason" class="form-label">Reason For Flag</label>
                        <textarea type="text" class="form-control" id="flagReason" [(ngModel)]="flagReason" rows="3"
                            name="flagReason"></textarea>
                    </div>
                </div>
                <div class="row mt-3  d-flex justify-content-center" *ngIf="examSchedule.status != 'InProgress'">
                    <div class=" d-flex justify-content-center">
                        <button type="submit" class="btn btn-primary col-md-5 mr-1"
                            [disabled]="!flagReason">Save</button>
                        <button type="button" class="btn btn-secondary col-md-5" (click)="close()">Cancel</button>
                    </div>
                </div>
            </form>

        </div>
    </div>
</div>